import { render, staticRenderFns } from "./StatisticCardHorizontal.vue?vue&type=template&id=756aaff0&scoped=true&"
import script from "./StatisticCardHorizontal.vue?vue&type=script&lang=js&"
export * from "./StatisticCardHorizontal.vue?vue&type=script&lang=js&"
import style0 from "./StatisticCardHorizontal.vue?vue&type=style&index=0&id=756aaff0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "756aaff0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\KoushalManna\\Projects\\NPCC\\NPCC_UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('756aaff0')) {
      api.createRecord('756aaff0', component.options)
    } else {
      api.reload('756aaff0', component.options)
    }
    module.hot.accept("./StatisticCardHorizontal.vue?vue&type=template&id=756aaff0&scoped=true&", function () {
      api.rerender('756aaff0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/reports/accountingreport/StatisticCardHorizontal.vue"
export default component.exports